function AriaHidden() {
  return (
    <blockquote className="p-4 bg-white">
      <h4 className="h6 mb-3">What It Means</h4>
      <p>Content is hidden with ARIA.</p>
      <h4 className="h6 mb-3">Why It Matters</h4>
      <p>Content hidden with aria-hidden="true" is not presented to screen reader users.</p>
      <h4 className="h6 mb-3">What To Do</h4>
      <p>Ensure the content is intended to be hidden from screen reader users. The hidden content must not contain any navigable elements (such as links or form controls).</p>
    </blockquote>
  )
}

export default AriaHidden